import { Transition } from "../Transition/index.js";
import morphdom from "morphdom";
class FrameTarget extends Transition {
  /**
   * Config.
   */
  static config = {
    name: "FrameTarget",
    options: {
      mode: {
        type: String,
        default: "replace"
        // or 'prepend' or 'append'
      }
    }
  };
  /**
   * Different mode of content insertion.
   */
  modes = {
    APPEND: "append",
    PREPEND: "prepend",
    REPLACE: "replace",
    MORPH: "morph"
  };
  /**
   * Get uniq ID.
   */
  get id() {
    return this.$el.id;
  }
  /**
   * Update the content from the new target.
   */
  async updateContent(content = null) {
    if (!content) {
      return;
    }
    const { mode } = this.$options;
    const { $el, modes } = this;
    if (mode === modes.APPEND || mode === modes.PREPEND) {
      const leaveTargets = Array.from($el.children);
      const enterTargets = Array.from(content.children);
      $el[mode](...Array.from(content.childNodes));
      await Promise.all([
        this.leave(leaveTargets),
        this.enter(enterTargets)
      ]);
    } else {
      await this.leave();
      if (mode === modes.MORPH) {
        morphdom($el, content);
      } else {
        $el.replaceChildren(...Array.from(content.childNodes));
      }
      await this.enter();
    }
  }
}
export {
  FrameTarget
};
//# sourceMappingURL=FrameTarget.js.map
